const makeValue = ({ plot, phase }) => {
  return new Promise(async(resolve) => {
    let url = `https://quick.wayfindit.com/${plot.appId}/${phase.appId}`;
    resolve(url);
  })
};

export default makeValue;